"use client";

import Image from "next/image";
import { useState } from "react";
import { integrationIconSrc } from "@/components/molecules/IntegrationLogo/helpers";

interface Props {
  id: string;
  name: string;
}

export function ProviderAvatar({ id, name }: Props) {
  const src = integrationIconSrc(id);
  const [brokenSrc, setBrokenSrc] = useState<string | null>(null);
  if (!src || brokenSrc === src) {
    return (
      <div
        aria-hidden
        className="flex size-10 shrink-0 items-center justify-center rounded-md bg-surface-hover text-body-lg leading-inherit font-semibold text-foreground-secondary uppercase"
      >
        {name?.charAt(0) ?? id.charAt(0)}
      </div>
    );
  }
  return (
    <Image
      src={src}
      alt={`${name} logo`}
      width={40}
      height={40}
      loading="lazy"
      onError={() => setBrokenSrc(src)}
      className="size-10 shrink-0 object-contain"
    data-sentry-element="Image" data-sentry-component="ProviderAvatar" data-sentry-source-file="ProviderAvatar.tsx" />
  );
}
